export interface GetAmbarAgreementListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetAmbarAgreementListPagingAndFilterResponseData
}

export interface GetAmbarAgreementListPagingAndFilterResponseData {
    items: GetAmbarAgreementListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetAmbarAgreementListPagingAndFilterResponseItem {
    ambarAgreementId: string
    companyId: string
    refNo?: string
    agreementSchemeId: string
    potTypeId: string
    startDate: string
    endDate: string
    unitPrice: number
    minPrice: number
    agreementSchemeName: string
    potTypeName: string
    ambarAgreementScales: GetAmbarAgreementListPagingAndFilterResponseAmbarAgreementScale[]
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export interface GetAmbarAgreementListPagingAndFilterResponseAmbarAgreementScale {
    ambarAgreementScaleId: string
    ambarAgreementId: string
    startPrice: number
    unitPrice: number
    interval: number
}

export const initialGetAmbarAgreementListPagingAndFilterResponseData: GetAmbarAgreementListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}